import React from 'react';
import {
    MemberItem as StyledMemberItem,
    MemberInfo,
    Avatar,
    RoleSelect,
    RemoveButton
} from '../../styles/ManageWorkspaceMembers.styles';

const MemberItem = ({ uid, member, isCurrentUser, onRoleChange, onRemove }) => (
    <StyledMemberItem>
        <MemberInfo>
            <Avatar>
                {member.displayName?.charAt(0) || member.email?.charAt(0)}
            </Avatar>
            <div>
                <div>{member.displayName || member.email}</div>
                <div style={{ fontSize: '12px', color: '#8C9BAB' }}>
                    {member.email}
                </div>
            </div>
        </MemberInfo>
        <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
            <RoleSelect
                value={member.role}
                onChange={e => onRoleChange(uid, e.target.value)}
                disabled={isCurrentUser}
            >
                <option value="admin">Admin</option>
                <option value="member">Member</option>
            </RoleSelect>
            {!isCurrentUser && (
                <RemoveButton onClick={() => onRemove(uid)}>
                    Remove
                </RemoveButton>
            )}
        </div>
    </StyledMemberItem>
);

export default MemberItem;